import { OrgDto } from './org';

export const fakeOrgDto = (): OrgDto => {
  return {
    id: 5,
    tz: 'America/New_York',
    name: 'ACME',
  };
};
